// Real local file operations via the browser File System Access API.
// Everything happens ONLY inside a directory the user explicitly grants.
export function fsSupported() {
  return typeof window !== "undefined" && "showDirectoryPicker" in window;
}

export async function pickDirectory() {
  const handle = await window.showDirectoryPicker({ mode: "readwrite" });
  return handle;
}

export async function listEntries(dirHandle) {
  const out = [];
  for await (const [name, handle] of dirHandle.entries()) {
    out.push({ name, kind: handle.kind });
  }
  return out.sort((a, b) => (a.kind === b.kind ? a.name.localeCompare(b.name) : a.kind === "directory" ? -1 : 1));
}

export async function createFolder(dirHandle, name) {
  await dirHandle.getDirectoryHandle(name, { create: true });
}

export async function readFileText(dirHandle, name) {
  const fh = await dirHandle.getFileHandle(name);
  const file = await fh.getFile();
  return await file.text();
}

export async function deleteEntry(dirHandle, name) {
  await dirHandle.removeEntry(name, { recursive: true });
}

// Rename: prefer native move(); fall back to copy+delete for files.
export async function renameEntry(dirHandle, from, to) {
  const fh = await dirHandle.getFileHandle(from).catch(() => null);
  if (fh && typeof fh.move === "function") {
    await fh.move(to);
    return;
  }
  if (fh) {
    const file = await fh.getFile();
    const dest = await dirHandle.getFileHandle(to, { create: true });
    const w = await dest.createWritable();
    await w.write(await file.arrayBuffer());
    await w.close();
    await dirHandle.removeEntry(from);
    return;
  }
  throw new Error("Only files can be renamed here");
}
